<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>
          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">{{TitleIndex}}</p>
                <div class>
                  <div class id="tabela-propostas">
                    <section id="proposta-dashboard" class="column">
                      <section id="entity-content">
                        <proposta-form
                          :formtitle="TitleIndex"
                          :proposta="proposta"
                          @formSubmit="FormSubmit"
                          :buttom="TitleForm"
                        />
                      </section>
                    </section>
                  </div>
                </div>
              </div>
              <internfooter />
            </div>
            
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PropostaService from "@/services/PropostaService";
import PropostaForm from "@/components/Forms/Proposta";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import store from "@/store";

export default {
  name: "propostaNew",
  props: [],
  created() {
    var PropostaId = this.$router.history.current.params.uuid;
    if(PropostaId != null){
      PropostaService.Info(PropostaId).then(result => {
        this.proposta = result.data;
      });
    }
  },
  methods: {
    CreateProposta(proposta) {
      PropostaService.Create(proposta).then(() => {
        this.$buefy.toast.open({
          duration: 5000,
          message: "Proposta criada com sucesso!",
          position: "is-top-right",
          type: "is-success"
        });
        this.$router.push({ name: "proposta" });
      });
    },
    UpdateProposta(proposta) {
      PropostaService.Update(this.$route.params.uuid, proposta)
        .then(() => {
          this.$buefy.toast.open({
            duration: 5000,
            message: "update realizado com sucesso!",
            position: "is-top-right",
            type: "is-success"
          });
          this.$router.push({ name: "proposta" });
        });
    },
    FormSubmit(proposta){
      if(this.proposta.id == ""){
        this.CreateProposta(proposta);
      }else{
        this.UpdateProposta(proposta);
      }
    }
  },
  computed: {
    TitleForm: function(){
        return this.proposta.id == "" ? "Criar Proposta" : "Editar Proposta";
    },
    TitleIndex: function(){
        return this.proposta.id == "" ? "Cadastrar Nova Proposta" : "Alterar Proposta";
    }
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    PropostaForm: PropostaForm
  },
  data() {
    return {
      proposta: {
          created_at:"",
          grade:"",
          grade_id:"",
          id:"",
          nome:"",
          numero:"",
          url:"",
          videos: [],
          escolas: []
      },
      cargo: store.getters.cargo,
      cargoId: store.getters.cargo_id
    };
  }
};
</script>